import { useTranslation } from "react-i18next";

import { ROUTES } from "@/shared";

import FilterDropdown from "../../FilterDropdown/FilterDropdown";
import { FILTER_NAMES, TRANSLATE_STRINGS } from "../../types/enums";

const VehicleFilesFilters = () => {
  const { t } = useTranslation();

  return (
    <FilterDropdown
      route={ROUTES.VehicleFiles}
      filterName={FILTER_NAMES.Schedule}
      placeholder={t("Filter##schedule")}
      translateString={TRANSLATE_STRINGS.Table}
    />
  );
};

export default VehicleFilesFilters;
